/* global Prism */
function wrap(code) {
    return `<code>${code}</code>`;
}

export default (str, lang) => {
    if (!lang) {
        return wrap(str);
    }
    lang = lang.toLowerCase();
    if (lang === "vue" || lang === "html") {
        lang = "markup";
    }
    if (lang === "md") {
        lang = "markdown";
    }
    if (lang === "ts") {
        lang = "typescript";
    }
    if (Prism.languages[lang]) {
        const code = Prism.highlight(str, Prism.languages[lang], lang);
        return wrap(code);
    }
    return wrap(str);
};
